import React from 'react';
import { AlertTriangle } from 'lucide-react';

// Shown in place of a list's "No results" state when the list request failed,
// so a server or connection error isn't mistaken for an empty list.
//
// Can also wrap the list: <ListLoadError show={failed} ...>{list}</ListLoadError>
// renders the list when `show` is false. Very large pages use this form because
// adding one more JSX branch to them trips eslint-plugin-react-hooks 1.x, which
// then wrongly reports their hooks as "called conditionally".
const ListLoadError = ({ what = 'this list', onRetry, show = true, children = null }) => {
  if (!show) return children;
  return (
    <div className="empty-state">
      <div className="empty-state-content">
        <div className="icon">
          <AlertTriangle size={56} color="#ADB5BD" strokeWidth={1.5} />
        </div>
        <h1 className="no-item-title mt-2">Couldn't load {what}</h1>
        <p className="no-item-text">The server or connection had a problem. Your search and filters are kept.</p>
        {onRetry && (
          <button type="button" className="dark-border mt-3" onClick={onRetry}>
            Try again
          </button>
        )}
      </div>
    </div>
  );
};

export default ListLoadError;
